export const ACCOUNT_LOCATIONS = (id, params) => `/accounts/${id}/locations?${params}`;

export const USER_LOCATION_LIST = '/user/location-list';
export const LOCATION_AGREE_CONTRACT = (id) => `/locations/${id}/agree-contract`;
export const GET_SEARCH_QUERY_JOB_PROGRESS = (params) => `/get-job-progress?${params}`;
export const SEARCH_KEYWORD = (params) => `/search?${params}`;
export const GET_ARTICLE = (params) => `/articles?${params}`;
export const GET_MY_WEBSITE = (params) => `/my-websites?${params}`;
export const GET_MAIN_KEYWORDS = (params) => `/get-main-keywords/${params}`;
export const GET_BUSINESS_KEYWORDS = (params) => `get-keywords-for-business?${params}`;
export const GET_KEYWORD_SERP_FEATURES = (keywordId) => `keywords/${keywordId}/serp-features`;
export const GET_LOCAL_KEYWORDS = (params) => `get-keywords-for-local?${params}`;
export const STORE_MAIN_KEYWORD = `/store/main-keywords`;
export const DISPATCH_MANUAL_JOB = '/main-keywords/dispatch-manual-job';
export const USER_LINE_OFFICIAL_TALK_ID = `user/line-official-talk-id`;
export const USER_NOTIFICATION_SETTINGS = `/user/notification-settings`;
export const USER_NOTIFICATION_EMAIL = `/user/notificaiton-email`;
export const GEO_LOCAL_AREA_LISTS = `/geo/local-area`;
export const GEO_LOCAL_AREA_REGISTRATION = `/geo/local-area/register`;
export const GEO_LOCAL_AREA_INFO = '/geo/local-area/info';
export const GEO_LOCAL_AREA_CLEAR = '/geo/local-area/clear';
export const GEO_LOCAL_AREA_SEARCH = '/geo/local-area/search';
// export const BACKLINK_CSV_DOWNLOAD = (params) => `/backlinks/csv?${params}`;
export const BACKLINK_CSV_DOWNLOAD = '/backlink-csv';
export const BACKLINK_CSV_LIST = '/backlink-csv';
export const BACKLINK_CSV_DELETE = '/backlink-csv';
export const BACKLINK_CSV_DOWNLOAD_FILE = '/backlink-csv';
export const BUSINESS_KEYWORD_CSV_LIST = '/business-keyword-csv';
export const BUSINESS_KEYWORD_CSV_DOWNLOAD = '/business-keyword-csv';
export const BUSINESS_KEYWORD_CSV_DELETE = '/business-keyword-csv';
export const UPLOAD_QUEUE = '/upload-queues';
export const SINGLE_UPLOAD_QUEUE = (id) => `/upload-queue-data/${id}`;

export const PURCHASE_LOGS = (params) => `/credits/purchase-logs?${params}`;
export const CONSUMPTION_HISTORY = (params) => `/credits/expense-logs?${params}`;
export const CREDIT_HISTORY = (params) => `/credits/credit-history?${params}`;
export const EXCLUDE_KEYWORD = `/exclude-keyword`;

export const BUSINESS_KEYWORD_CSV_UPLOAD = `/business-keyword-upload-csv`;
export const WEBSITE_LIST_CSV_UPLOAD = '/csv-upload/list-send-screen';
export const DOWNLOAD_SAMPLE_CSV = (params) => `/sample-csv-download?${params}`;
export const TEMPLATE_CSV_UPLOAD = '/user-profile-template/bulk/csv-upload';
export const DOWNLOAD_SAMPLE_TEMPLATE_CSV = '/sample-csv-download?type=user_profile';

export const LOCAL_KEYWORD_CSV_LIST = '/local-keyword-csv';
export const LOCAL_KEYWORD_CSV_DOWNLOAD = '/local-keyword-csv';
export const LOCAL_KEYWORD_CSV_DELETE = '/local-keyword-csv';
export const STORE_USER_TEMPLATE = '/user-profile-template';
export const FETCH_USER_TEMPLATE_BY_LOCATION = '/user-profile-template/location-wise-templates';
export const FETCH_LATEST_USER_TEMPLATE_BY_LOCATION = '/user-profile-template/latest-by-location';
export const CREATE_USER_PATTERN_URL = '/reply-templates';
export const SHOW_SINGLE_TEMPLATE = (id) => `/reply-templates/${id}`;
export const DELETE_REPLY_TEMPLATE_BY_ID = (id) => `/reply-templates/${id}`;
export const UPDATE_REPLY_TEMPLATE_BY_ID = (id) => `/reply-templates/${id}`;
export const FETCH_SINGLE_TEMPLAE_BY_ID = (params) => `/user-profile-template/${params}`;
export const UPDATE_SINGLE_TEMPLATE_BY_ID = (params) => `/user-profile-template/${params}`;
export const SINGLE_TEMPLATE_BY_ID = (id) => `/user-profile-template/${id}`;
export const UPDATE_OR_REGEN_TEMPLATE = (id) => `/user-profile-template/regenerate-or-update-inquire-template/${id}`;
export const MAKE_DEFAULT_TEMPLATE = (id) => `/user-profile-template/make-default/${id}`;
export const UPDATE_REPLY_TEMPLATE = (id) => `/user-profile-template/update-reply-template/${id}`;

export const EXTRACT_ARTICLES_URL = '/propose-articles/extract';
export const EXTRACT_PREFILL_URL = '/propose-articles/extract-prefill';
export const EXTRACTION_HISTORIES_URL = '/propose-articles/extraction-histories';
export const EXTRACTED_ARTICLES_URL = '/propose-articles/extracted-articles';
export const BULK_UPDATE_EXTRACTED_ARTICLES_ENABLED_URL = '/propose-articles/extracted-articles/bulk-enabled';
export const BULK_DELETE_EXTRACTED_ARTICLES_URL = '/propose-articles/extracted-articles/bulk';
export const UPDATE_EXTRACTED_ARTICLE_ENABLED_URL = (id) => `/propose-articles/extracted-articles/${id}/enabled`;
export const EXTRACTED_ARTICLE_BY_ID_URL = (id) => `/propose-articles/extracted-articles/${id}`;
export const RECRAWL_EXTRACTION_HISTORY_URL = (id) => `/propose-articles/extraction-histories/${id}/recrawl`;
export const RECRAWL_EXTRACTED_ARTICLE_URL = (id) => `/propose-articles/extracted-articles/${id}/recrawl`;
export const PROPOSALS_URL = '/propose-articles/proposals';
export const PROPOSAL_GROUP_URL = '/propose-articles/proposals/group';
export const PROPOSAL_EXTRA_SITES_URL = '/propose-articles/proposals/extra-sites';
export const GENERATE_PROPOSAL_URL = '/propose-articles/proposals/generate';
export const REGENERATE_PROPOSAL_INTRODUCTION_URL = '/propose-articles/proposals/regenerate-introduction';
export const REGENERATE_PROPOSAL_EMAILS_URL = '/propose-articles/proposals/regenerate-emails';
export const UPDATE_PROPOSAL_EMAIL_URL = '/propose-articles/proposals/emails';
export const PROPOSAL_BY_ID_URL = (id) => `/propose-articles/proposals/${id}`;
export const PROPOSAL_HISTORIES_URL = '/propose-articles/proposals/histories';

//Rewrite article
export const GET_REWRITE_KEYWORDS = (params) => `get-keywords-for-rewrite?${params}`;
export const REWRITE_KEYWORD_CSV_LIST = '/rewrite-keyword-csv';
export const REWRITE_KEYWORD_CSV_DOWNLOAD = '/rewrite-keyword-csv';

// Badge Configuration
export const UPDATE_LOCATION_CONFIGURATION = (id) => `/locations/${id}/configuration`;
export const UPDATE_LOCATION_SCHEDULAR_CONFIGURATION = (id) => `/locations/${id}/schedular-configuration`;
export const UPDATE_SMTP_CONFIGURATION = (id) => `/locations/${id}/smtp-configuration`;

// Credit Management
export const CREDIT_PURCHASE_HISTORY = '/credits/csv';

// Email Reply featrue
export const GET_EMAIL_REPLIES = (id) => `/get-email-replies/${id}`;
export const GET_UNTRACK_EMAIL_REPLIES = `/untrack-email-replies`;
export const SEND_EMAIL_REPLY = `/send-email-reply`;
export const ATTACH_UNTRACK_EMAIL_REPLY = `/attach-untrack-email-reply`;
export const DETACH_UNTRACK_EMAIL_REPLY = `/detach-untrack-email-reply`;
export const TOGGLE_HIDE_UNTRACK_EMAIL_REPLY = `/toggle-hide-untrack-email-reply`;
export const RESTORE_HIDDEN_UNTRACK_EMAIL_REPLIES = `/restore-hidden-untrack-email-replies`;
export const GET_TEMPLATE_EMAILS = '/get-template-emails';
export const VERIFY_TEMPLATE_EMAIL = (id) => `verify-email-to-ses/${id}`;
export const RECIPIENT_EMAIL_LIST = `/recipient-email-list`;


export const DASHBOARD_STATS = '/client-dashboard';
export const DASHBOARD_GSC_STATS = '/client-dashboard-gsc-data';
export const DASHBOARD_GSC_ADDITIONAL_STATS = '/client-dashboard-gsc-additional-data';
// Article image generation
export const ARTICLE_IMAGE_DESIGN_TASTES = '/article/image-design-tastes';
export const ARTICLE_IMAGE_GENERATION = (articleId) => `/article/${articleId}/image-generation`;
export const ARTICLE_IMAGE_EDIT = (articleId) => `/article/${articleId}/image-generation/edit`;

// Article Author Profiles
export const ARTICLE_AUTHOR_PROFILE_BASE = '/article-author-profiles';
export const ARTICLE_AUTHOR_PROFILE_SINGLE = (id) => `/article-author-profiles/${id}`;
export const ARTICLE_AUTHOR_PROFILE_SET_ACTIVE = (id) => `/article-author-profiles/set-active/${id}`;

// Sub keywords
export const STORE_SUB_KEYWORD = '/store-sub-keyword';
export const GET_SUB_KEYWORDS = '/get-sub-keywords';

// Keyword credit preview & retry
export const CREDIT_PREVIEW = '/keywords/credit-preview';
export const RETRY_PIPELINE = (id) => `/keywords/${id}/retry-pipeline`;
export const ADD_MORE_MAIN_KEYWORDS = (id) => `/main-keywords/${id}/add-more-keywords`;
export const ADD_MORE_SUB_KEYWORDS = (id) => `/sub-keywords/${id}/add-more-keywords`;

// Super user
export const SUPER_USER = '/check-superuser';
export const REMAINING_WEBSITES = '/remaining-website-list-count';
export const COMMON_CONSTANTS = '/get-common-constant-value';
